/**
 * Equipment type constants for rack canvas.
 * Single Responsibility: owns all type-to-display mappings.
 * Open/Closed: extend by merging custom configs — don't edit this file.
 */

/** Brand colors per equipment type (hex). Used for colored left-border and overlay. */
export const TYPE_COLORS: Record<string, string> = {
  server:        '#3b82f6',  // blue-500
  switch:        '#22c55e',  // green-500
  router:        '#06b6d4',  // cyan-500
  patch_panel:   '#a855f7',  // purple-500
  storage:       '#eab308',  // yellow-500
  firewall:      '#ef4444',  // red-500
  pdu:           '#f97316',  // orange-500
  ups:           '#14b8a6',  // teal-500
  organizer:     '#64748b',  // slate-500
  blanking_panel:'#1e293b',  // slate-800
  unknown:       '#64748b',  // slate-500
};

/** Russian display names per equipment type. */
export const TYPE_NAMES_RU: Record<string, string> = {
  server:        'Сервер',
  switch:        'Коммутатор',
  router:        'Маршрутизатор',
  patch_panel:   'Патч-панель',
  storage:       'СХД',
  firewall:      'Файрвол',
  pdu:           'PDU',
  ups:           'ИБП',
  organizer:     'Организатор',
  blanking_panel:'Заглушка',
  unknown:       'Устройство',
};

/** Returns device status category for status-indicator dot. */
export function getDeviceStatus(status: unknown): 'ok' | 'warning' | 'critical' | 'unknown' {
  if (typeof status !== 'string' || !status) return 'unknown';
  const s = status.toLowerCase();
  if (s === 'failed' || s === 'decommissioning' || s === 'offline') return 'critical';
  if (s === 'staged' || s === 'planned' || s === 'inventory') return 'warning';
  return s === 'active' ? 'ok' : 'unknown';
}
